<template>
  <div class="field_content">
        <!-- <span v-show='focus'>请描述您的特殊需求…</span> -->
        <img src='/images/public/placeholder.png' class='field_bg' :class='{active:!focus}'  v-show='!hasMes' @click='img_click()'>           
        <van-field
            v-model="message"
            class='field'
            type="textarea"
            ref='field'
            rows='5'
            @focus='getfocus'
            @blur='getblur'
            :class='{padding:focus}'
            :placeholder="placeholder"
            @input='onChange'
        />
  </div>
</template>

<script>
  export default {
    name: 'field',
    props: {
        // message : {
        //     type : String,
        //     default : ''
        // }
    },
    data () {
        return {
            focus : true,
            message : '',
            placeholder : '',
            hasMes : false
        }
    },
    watch: {},
    computed: {
        
    },
    created () {
    },
    mounted () {
    },
    methods: {
        onChange(){
          
            this.message?this.hasMes = true:this.hasMes = false
            
        },
        img_click(){
            this.$refs.field.focus();
        },
        getfocus(){
            this.focus = false;
        },
        getblur(){
            if(this.message.length == 0){
                this.focus = true;
            }
            this.$emit('changeMessage',this.message)
        }
    }

  }
</script>

<style lang="scss" scoped>
    .field_bg{
        position: absolute;
        top:35px; 
        left:36px;
        z-index: 9;
        user-select: none;  
        -moz-user-select: -moz-none; 
        -ms-user-select: none;      
        width: 600px;
    }
    .padding{
        padding-top:80px!important;
    }
    .field_content{
        margin-top: 25px;
        position: relative;
        span{
            color:rgba(74,74,74,1);
            line-height:36px;
            font-size: 28px;
            position: absolute;
            z-index: 9;
            padding-left:40px;
            top:30px; 
        }
    }
    .field{
        position: relative;
        z-index: 5;
        border-radius: 4px;
        padding:26px 30px;
        color:#9B9B9B;
        border:1px solid rgba(74,74,74,0.5);
        height: 320px;
        ::-webkit-input-placeholder { /* WebKit browsers */
            color: #9B9B9B;
            font-size: 24px;
        }
    }
</style>
